<template>
  <li @click="dumpContext" class="wt-storyboard-preview-item no-transition">
    <div>
      <div class="wt2-poster" @click.prevent="onClick">
        <div class="wt2-thumbnail-hover -no-gradient" :data-id="story.id">
          <i class="wticon wticon-play3" />
          <div class="-info">
            <i v-if="story.type === 'VO'" class="wticon wticon-mic" />
          </div>

          <div
            v-if="showAddButton"
            class="-open-menu -gray js-stop"
            :title="'storyboards.add2MyTemplates' | culture"
            :class="{ '-active': isDuplicating }"
            @click="!isDuplicating && $emit('add')"
          >
            <i
              v-if="!isDuplicating"
              class="wticon wticon-plus-circle js-stop"
            />
            <wt-google-like-loader v-else class="-default" />
          </div>

          <div
            v-if="showTouchButton"
            class="-top-right-badge -secondary js-stop"
            :class="{ '-active': isMovingToTop }"
            :title="'Move to Top'"
            :data-enabled="'true'"
            @click="
              !isPublishing2Frame &&
                $emit('move-to-top', {
                  video: story,
                })
            "
          >
            <wt-google-like-loader v-if="isMovingToTop" class="-default" />
            <i v-else class="wticon wticon-arrow-up js-stop" />
          </div>

          <div
            v-if="showPublish2FrameButton"
            class="-top-right-badge js-stop"
            :class="{ '-active': isPublishing2Frame }"
            :title="publish2FrameTooltip"
            :data-enabled="String(story.shortcutEnabled)"
            @click="
              !isPublishing2Frame &&
                $emit('publish-to-frame', {
                  video: story,
                  enableFrame: !story.shortcutEnabled,
                })
            "
          >
            <wt-google-like-loader v-if="isPublishing2Frame" class="-default" />
            <i
              v-else-if="story.shortcutEnabled"
              class="wticon wticon-show js-stop"
            />
            <i
              v-else-if="!story.shortcutEnabled"
              class="wticon wticon-hide js-stop"
            />
          </div>
        </div>
        <div class="-inner">
          <img v-if="poster" :src="poster" />
        </div>
      </div>
      <footer class="wt-preview-item-footer">
        <div class="-top-line">
          <wt-aspect-ratio-tag :id="story.aspectRatio" />
        </div>
        <div class="-bottom-line">
          <div
            class="wt2-title"
            :title="story.title"
            v-text="story.title || 'Untitled Video'"
          />
        </div>
      </footer>
    </div>
  </li>
</template>

<script>
import app from 'app';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'storyboard-preview-item',

  props: {
    story: { type: Object, required: true },
    tab: { type: String },
    index: { ype: Number },
    showAddButton: { type: Boolean, default: false },
    showPublish2FrameButton: { type: Boolean, default: false },
    showTouchButton: { type: Boolean, default: false },
    isDuplicating: { type: Boolean, default: false },
    isPublishing2Frame: { type: Boolean, default: false },
    isMovingToTop: { type: Boolean, default: false },
  },

  data: function () {
    return {};
  },

  computed: {
    ...mapGetters(['selectedStory']),

    poster() {
      return this.mixinSrc(this.story.thumbnailPath, this.story.posterPath);
    },

    duration() {
      const videoDuration = window.parseFloat(this.story.videoDuration);
      const durationMs = Math.floor(videoDuration * 1000);

      return app.moment.utc(durationMs).format('m:ss');
    },

    publish2FrameTooltip() {
      return this.isPublishing2Frame
        ? app.culture.generic.PROCESSING
        : this.story.shortcutEnabled
        ? app.culture.storyboards.published2frame_yes
        : app.culture.storyboards.published2frame_no;
    },
  },

  methods: {
    ...mapMutations(['setSelectedStory']),

    onClick(e) {
      if (
        (e && (e.metaKey || e.ctrlKey)) ||
        (e && e.target.classList.contains('js-stop'))
      ) {
        return;
      }
      this.$emit('select', { e, story: this.story });
    },

    leave() {
      console.log('leave');
    },

    /**
     * @param e {Event}
     */
    dumpContext(e) {
      if (e.metaKey || e.ctrlKey) {
        this.$log('Story preview', this.story);
      }
    },
  },
};
</script>

<style lang="scss">
.wt-storyboard-preview-item {
  --box-size: 22px;
  --box-padding: 10px;

  .-top-right-badge {
    position: absolute;
    top: var(--box-padding);
    right: var(--box-padding);
    width: var(--box-size);
    height: var(--box-size);
    font-size: 15px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;

    &.-secondary {
      right: calc(var(--box-padding) + (var(--box-size) * 1.2));
    }

    &[data-enabled='true'] {
      background-color: #dbdb50;
    }
    &[data-enabled='false'] {
      background-color: #d9d9d9;
    }
    &.-active {
      background-color: transparent;
    }

    .wticon {
      &:before {
        color: black;
      }
    }
  }
}
</style>
